export const VALIDATE_LOGIN_ACCESS="VALIDATE_LOGIN_ACCESS";
export const GET_LOGIN_USER="GET_LOGIN_USER";
export const CREATE_USER="CREATE_USER";
export const RESET_PASSWORD="RESET_PASSWORD";
export const GET_USER_STATUS="GET_USER_STATUS";
export const GET_LOGIN_HISTORY="GET_LOGIN_HISTORY";